<div class="content-card">
  <h2 class="content-card__header">{{ 'AF-TheSetOfDocumentsVersion' | translate }}</h2>

  <div [formGroup]="agreementFormGroup">
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AEF-TheSetOfDocumentsVersion' | translate }}</mat-label>
          <mat-select formControlName="agreementTemplate" required>
            @for (template of listOfAgreementTemplates$ | async; track template) {
              <mat-option [value]="template.Id">
                {{ template.Name }}
              </mat-option>
            }
          </mat-select>
          @if (agreementTemplate.invalid && agreementTemplate.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      @if (isEmploymentConditionsConfirmationTemplateVisible()) {
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AEF-EmploymentConditionsConfirmationTemplate' | translate }}</mat-label>
            <mat-select formControlName="employmentConditionsConfirmationTemplate" required>
              @for (template of employmentConditionsConfirmationTemplates$ | async; track template) {
                <mat-option [value]="template.Id">
                  {{ template.Name }}
                </mat-option>
              }
            </mat-select>
            @if (employmentConditionsConfirmationTemplate.invalid && employmentConditionsConfirmationTemplate.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div class="row">
      <div class="col">
        <button class="mr-3" mat-raised-button color="primary" matStepperPrevious>{{ 'Back' | translate }}</button>
        <button mat-raised-button color="primary" [disabled]="agreementFormGroup.invalid" (click)="onGenerateDocument()">
          {{ 'AF-GenerateDocument' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
